var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraduationStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 50,
    viewBox: "0 0 35 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "etoile",
    transform: "translate(-134 -315)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(134 315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1706",
    "data-name": "Trac\\xE9 1706",
    d: "M455.17,905l-6.468-1.2-4.657,4.646-.855-6.523-5.858-2.993,5.939-2.829,1.037-6.5,4.526,4.774,6.5-1.021-3.142,5.779Z",
    transform: "translate(-14.481 -658.734) rotate(17)",
    fill: "#f6c459"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationStar);
export default __webpack_public_path__ + "static/media/graduation_star.b0fb0fd8fb0591b8421c3fb4e019c138.svg";
export { ForwardRef as ReactComponent };